import { defineMessages } from 'react-intl';

const messages = defineMessages({
  message0: 'Retro mountain with trees',
  message1: 'Cats and funny memes',
  message2: 'Cars and auto racing',
  message3: 'Fantasy dragons and magic',
  message4: 'Black and white sci-fi',
  message5: 'Puns and memes and funny sayings',
  message6: 'Retro 70s and 80s nostalgia',
  message7: 'Flowers and gardening',
  message8: 'Mind and wellness quotes',
  message9: 'Pastel art nouveau'
});

export const useEngageTextMessaging = intl => {
  return Object.keys(messages).map(key => intl.formatMessage(messages[key]));
};
